export default __webpack_public_path__ + "static/media/global-mic.5ad2edf9.png";